import { takeEvery, put, call } from "redux-saga/effects";
import {
  FETCH_SHIFT_GROUPS, CREATE_SHIFT_GROUP, UPDATE_SHIFT_GROUP, DELETE_SHIFT_GROUP
} from "./actionTypes";
import {
  fetchShiftGroupsSuccess, fetchShiftGroupsFailure,
  createShiftGroupSuccess, createShiftGroupFailure,
  updateShiftGroupSuccess, updateShiftGroupFailure,
  deleteShiftGroupSuccess, deleteShiftGroupFailure,
  fetchShiftGroups
} from "./actions";
import { post, update, del } from "../../../helpers/api_helper";
import Swal from "sweetalert2";
import { showToast, showConfirm } from "../../../common/Toaster";

// Fetch Shift Groups
function* fetchShiftGroupsSaga(action) {
  try {
    const apiUrl = process.env.REACT_APP_GET_SHIFT_GROUP_API;
    const formData = new FormData();
    formData.append("unit_id", action.payload.unitId);
    const response = yield call(post, apiUrl, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve shiftsgroup!");
    }
    yield put(fetchShiftGroupsSuccess(response));
  } catch (error) {
    yield put(fetchShiftGroupsFailure(error.message));
  }
}

// Create Shift Group
function* createShiftGroupSaga({ payload }) {
  debugger
  try {
    const { formData, isEdit } = payload;
    const apiUrl = process.env.REACT_APP_CREATE_SHIFT_GROUP_API;
    console.log(apiUrl)
    const response = yield call(post, apiUrl, formData);
    if (response?.status === "success") {
      showToast({ icon: response?.status, title: response?.status, text: response.message });
      yield put(createShiftGroupSuccess(response));
      const unitId = formData.get("unit_id");
      if (unitId) {
        yield put(fetchShiftGroups(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      showToast({ icon: "error", title: "Error", text: response.message });
      yield put(createShiftGroupFailure(response));
    }
  } catch (error) {
    showToast({ icon: "error", title: "API Error", text: error.message });
    yield put(createShiftGroupFailure(error.message));
  }
}

// Update Shift Group
function* updateShiftGroupSaga({ payload }) {
  try {
    const response = yield call(update, `${process.env.REACT_APP_UPDATE_SHIFT_GROUP_API}/${payload.id}`, payload);
    yield put(updateShiftGroupSuccess(response));
  } catch (error) {
    yield put(updateShiftGroupFailure(error.message));
  }
}

// Delete Shift Group
function* deleteShiftGroupSaga({ payload }) {
  try {
    const apiUrl = process.env.REACT_APP_DELETE_SHIFT_GROUP_API;
    const response = yield call(post, apiUrl, payload);
    if (response?.status === "success") {
      showToast({ icon: "success", title: "Deleted", text: response.message });
      yield put(deleteShiftGroupSuccess(response));
    } else {
      showToast({ icon: "error", title: "Error", text: response.message });
    }
    yield put(deleteShiftGroupFailure(response));
  } catch (error) {
    showToast({ icon: "error", title: "API Error", text: error.message });
    yield put(deleteShiftGroupFailure(error.message));
  }
}

// Watcher Saga
function* shiftGroupSaga() {
  yield takeEvery(FETCH_SHIFT_GROUPS, fetchShiftGroupsSaga);
  yield takeEvery(CREATE_SHIFT_GROUP, createShiftGroupSaga);
  yield takeEvery(UPDATE_SHIFT_GROUP, updateShiftGroupSaga);
  yield takeEvery(DELETE_SHIFT_GROUP, deleteShiftGroupSaga);
}

export default shiftGroupSaga;
